// extracted by mini-css-extract-plugin
export default {"info":"AddressForm_info__Z-Sbk"};